import React, { ReactNode, FunctionComponent } from 'react'

export interface Props {
  title: ReactNode
  gridClass?: string
  children: ReactNode
}

export const Card: FunctionComponent<Props> = ({
  title,
  gridClass,
  children,
}) => (
  <div className={`card ${gridClass || null}`}>
    <div className="card__header">
      <h2 className="card__title">{title}</h2>
    </div>
    <div className="card__body">{children}</div>
  </div>
)

Card.displayName = 'Card'
